module.exports = __webpack_public_path__ + "static/media/BikeSharing.62ca957e.pdf";